
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-the-title",
      function () {
        return require("private-next-pages/about-the-title.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-the-title"])
      });
    }
  